import {SiteStore} from '@wix/wixstores-client-core/dist/es/src/viewer-script/site-store/siteStore';
import {getStoreMetaData} from './getProduct';
import {GetStoreMetaDataQuery} from '../graphql/queries-schema';

export class StoreMetaDataService {
  constructor(private readonly siteStore: SiteStore) {}

  public async fetchStoreInfo(): Promise<GetStoreMetaDataQuery> {
    try {
      const {data} = await getStoreMetaData(this.siteStore);
      return data;
    } catch (e) {
      //eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw Error;
    }
  }
}
